import api from './apiService'; // Your configured Axios instance

// 🧾 1. Register patient & lab orders
export const PatientRegistration_LabOrders = async (data, Order) => {
  try {
    const response = await api.post('Home/PatientRegistration', {
      patient: {
        PatientID: data.PatientID || null,
        PatientName: data.PatientName,
        ReferredBy: data.ReferredBy,
        ContactNumber: data.ContactNumber,
        Sex: data.gender,
        Age: data.Age,
        Comments: data.Comments,
        Address: data.Address,
        LaboratoryID: data.LaboratoryID
      },
      laborder: Order.map(order => ({
        TestID: order.TestID,
        GrandTotal: order.GrandTotal,
        TotalBill: order.TotalBill,
        Discount: order.Discount,
        CreatedBy: sessionStorage.getItem('UserID'),
        UpdatedBy: sessionStorage.getItem('UserID'),
        LaboratoryID: sessionStorage.getItem('LabID'),
      })),
      financialRecord: {
        LaboratoryID: sessionStorage.getItem('LabID'),
        createdBy: sessionStorage.getItem('UserID'),
        updatedBy: sessionStorage.getItem('UserID'),
        TotalBill: Order[0].TotalBill,
        Discount: Order[0].Discount,
        GrandTotal: Order[0].GrandTotal,
        ReceivedAmount: Order[0].ReceivedAmount,
        DueAmount: Order[0].DueAmount
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 🔍 2. Retrieve filtered + paginated patients
export const RetrivePatientsData = async (LabID, filters, pageNumber, pageSize) => {
  try {
    const response = await api.get(`/Home/GetPatient`, {
      params: {
        LabID,
        Year: filters.Year,
        PatientName: filters.PatientName,
        MRNo: filters.MRNo,
        PageNumber: pageNumber,
        PageSize: pageSize
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 👤 3. Get single patient
export const GetSinglepatient = async (id, LabID) => {
  try {
    const response = await api.get(`/Home/GetSinglePatient`, {
      params: {
        id,
        LabID
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 🔎 4. Global patient search
export const GloabalSearchPatient = async (labId, name) => {
  try {
    const response = await api.get(`/Home/PatientGloablSearch`, {
      params: {
        labid: labId,
        Name: name
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ❌ 5. Delete patient
export const DeletePatient = async (LabiD, PatientID) => {
  try {
    const response = await api.delete(`/Home/DeletePatient`, {
      params: {
        LabiD,
        PatientID
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✏️ 6. Update order comment
export const UpdateOrderComment = async (orderID, orderComment) => {
  try {
    const response = await api.post(`/Home/UpdateOrderComment`, {
      orderID,
      orderComment
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 📋 7. Get order comment
export const GetOrderComment = async (orderID) => {
  try {
    const response = await api.get(`/Home/GetOrderComment`, {
      params: { OID: orderID }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AddOrderPayment = async (Payload) => {
  try {
    const response = await api.post(`/Home/AddOrderPayment`, Payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
